module.exports = __webpack_public_path__ + "videos/webpush-chrome-desktop.33d1d12.webm";